import React from "react"
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import { FormSectionElements, FormSections, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { dateComparisonList, odsCallOutBoxs } from "../../entities/Constants";
import { Editor } from "primereact/editor";
import { MultiSelect } from "primereact/multiselect";
import Utils from "../../utilities/Utils";
import { InputTextarea } from "primereact/inputtextarea";


interface Props {
    ele: FormSectionElements;
    dialogVisible: boolean;
    isEng: boolean;
    callback;

}
interface State {
    // pickedFieldOptions;
}

export class DialogForLabelComponent extends React.Component<Props, State> {

    dateTypeFieldList = [];
    subSection: FormSubSections;
    additionalHtmlString = [];

    constructor(props: Props) {
        super(props);
        this.state = {
            pickedFieldOptions: [],
        };
        this.subSection = this.props.ele.parent as FormSubSections;
        this.dateTypeFieldList = this.subSection.ListOfFormSectionElements?.filter(p => p.Datatype === 'Date' && p.Sequence < this.props.ele.Sequence);
    }


    generateHtmlString = () => {
        let html = [];
        let contentHtml = this.otherPreviousFields();

        if (this.additionalHtmlString.length > 0) {
            contentHtml.push(this.additionalHtmlString);
            // this.additionalHtmlString=[];
        }

        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog
                    header={this.props.isEng ? "Field Properties for " + this.props.ele.ENUTitle : "Field Properties for " + this.props.ele.FRATitle} 
                    footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }}
                    onHide={() => this.props.callback(false)}
                >
                    {contentHtml}
                </Dialog>
            </>
        );
        return html;
    }


    otherPreviousFields = () => {
        let htmlString = [];

        htmlString.push(
            <div>
                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_" + this.props.ele.Sequence}>Field</label>
                    </div>
                    <div style={{ width: '60%', }}>
                        <InputText key={"tbl_" + this.props.ele.Sequence} value={this.props.ele.UpdateField} className="ontario-input"
                            onChange={(e) => { this.props.ele.UpdateField = e.target.value; this.props.callback() }} />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Question Hint</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Editor style={{ height: 'auto' }}
                            value={this.props.isEng ? this.props.ele.Hint : this.props.ele.HintFR} 
                            onTextChange={(e) => {
                                if (this.props.isEng)
                                    this.props.ele.Hint = e.htmlValue;
                                else
                                    this.props.ele.HintFR = e.htmlValue;
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Tool Tip</div>
                    <div style={{ width: '60%' }}>
                        <InputText className="ontario-input" 
                            value={this.props.isEng ? this.props.ele.TooltipENU : this.props.ele.TooltipFRA} 
                            onChange={(e) => {
                                if (this.props.isEng)
                                    this.props.ele.TooltipENU = e.target.value;
                                else
                                    this.props.ele.TooltipFRA = e.target.value;
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Wrap in Callout box</div>
                    <div style={{ width: '60%', }}>
                        {/* @ts-ignore */}
                        <Dropdown showClear className="ontario-dropdown-small" 
                            options={odsCallOutBoxs} 
                            optionLabel='label' 
                            optionValue='val' 
                            value={this.props.ele.wrapCalloutbox} 
                            onChange={(e) => {
                                this.props.ele.wrapCalloutbox = e.value;
                                this.props.callback();
                            }}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Add Callout Box</div>
                    <div style={{ width: '60%', }}>
                        {/* @ts-ignore */}
                        <Dropdown showClear className="ontario-dropdown-small" options={odsCallOutBoxs} optionLabel='label' optionValue='val' value={this.props.ele.callOutBoxType} onChange={(e) => {
                            this.props.ele.callOutBoxType = e.value;
                            this.props.callback();
                        }}></Dropdown>
                    </div>
                </div>

                <div style={{ display: this.props.ele.callOutBoxType != null ? "flex" : "none", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box Title</div>
                    <div style={{ width: '60%', }}><InputText className="ontario-input" value={this.props.isEng ? this.props.ele.callOutBoxTitle : this.props.ele.callOutBoxTitleFRA}
                        onChange={(e) => {
                            if (this.props.isEng)
                                this.props.ele.callOutBoxTitle = e.target.value;
                            else
                                this.props.ele.callOutBoxTitleFRA = e.target.value;

                            this.props.callback();
                        }}></InputText></div>
                </div>

                <div style={{ display: this.props.ele.callOutBoxType != null ? "flex" : "none", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Callout Box Body Message</div>
                    {/* <Editor value={p.Value} onTextChange={(e) => p.Value=e.htmlValue} style={{ height: 'auto' }}  /> */}
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Editor className="ontario-input" value={this.props.isEng ? this.props.ele.callOutBoxBody : this.props.ele.callOutBoxBodyFRA}
                            onTextChange={(e) => {
                                if (this.props.isEng)
                                    this.props.ele.callOutBoxBody = e.htmlValue;
                                else
                                    this.props.ele.callOutBoxBodyFRA = e.htmlValue;
                                this.props.callback();
                            }}></Editor>
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Stepper Script</div>
                    <div style={{ width: '60%'}}>                  
                    <InputTextarea className="ontario-input" 
                        value={this.props.ele.StepperScript} onChange={(e) => {
                        this.props.ele.StepperScript = e.target.value;
                        this.props.callback();
                    }}></InputTextarea></div>
                </div>

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Script</div>
                    <div style={{ width: '60%'}}>                  
                    <InputTextarea className="ontario-input" 
                        value={this.props.ele.Script} onChange={(e) => {
                        this.props.ele.Script = e.target.value;
                        this.props.callback();
                    }}></InputTextarea></div>
                </div>

            </div>
        )

        htmlString.push(this.generateFilter());

        return htmlString;
    }

    generateFilter = () => {
        let html = [];
        let allElements = [];
        let elementListWithOptions = [];

        let section = this.subSection.parent as FormSections;
        //get the section list prior to this one
        section.ListOfFormSubSections.forEach(sub => {
            let elementList = sub.ListOfFormSectionElements.filter(p => p.Sequence < this.props.ele.Sequence && sub.Sequence == this.subSection.Sequence || sub.Sequence < this.subSection.Sequence);
            allElements.push(...elementList);
        });

        let list = allElements.filter(
            (q) =>
                (q.Datatype === "RadioButton" ||
                q.Datatype === "CheckGroup" ||
                q.Datatype === "Dropdown")
        ).map((q) => {
            return {
                code: q.LoadBindName,
                description: this.props.isEng ? q.ENUTitle : q.FRATitle
            };
        });

        elementListWithOptions.push(...list);
    
        if (this.props.ele.FilterField == null || this.props.ele.FilterField == undefined) {
            this.props.ele.FilterField = [];

        }
        for (let option of elementListWithOptions) {
        
            let optionList = allElements.filter(p => p.LoadBindName == option["code"])[0].ListOfLOVValues;
            if (this.props.ele.FilterField.indexOf(option["code"]) == -1) {
                this.props.ele.FilterField.push(option["code"])
            }
            html.push(
                <>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Filtering Field</div>
                        <div style={{ width: '60%' }}>{this.props.isEng ? option["description"] : option["FRADescription"]}</div>
                    </div>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>Filtering Value</div>
                        <div style={{ width: '60%', }}>
                            <div>
                                {/* @ts-ignore */}
                                <MultiSelect style={{ width: '100%' }}
                                    className="ontario-dropdown-small"
                                    options={optionList}
                                    value={this.props.isEng ?
                                        (this.props.ele.FilterValue ? this.props.ele.FilterValue[option.code] : null) :
                                        (this.props.ele.FilterValueFRA ? this.props.ele.FilterValueFRA[option.code] : null)}
                                    optionLabel={this.props.isEng ? "description" : "FRADescription"}
                                    optionValue="code"
                                    placeholder="Filtering value"
                                    onChange={(e) => {

                                        if (Utils.isNullOrEmpty(this.props.ele.FilterValue))
                                            this.props.ele.FilterValue = {};
                                        if (this.props.isEng) {
                                            // if (this.props.ele.FilterValue[this.props.ele.FilterField]==null) {
                                            //     let obj = { [this.props.ele.FilterField]: e.value };
                                            //     this.props.ele.FilterValue.push(obj);
                                            //     console.log(this.props.ele);
                                            // } else {
                                            this.props.ele.FilterValue[option.code] = e.value;

                                            // }
                                        } else {

                                            if (this.props.ele.FilterValueFRA == null) {
                                                this.props.ele.FilterValueFRA = [];
                                            }
                                            this.props.ele.FilterValueFRA[option.code] = e.value;

                                        }
                                        this.props.callback();
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </>
            )


        }
        return html;
    }

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
